import Loader from "./components";

export default Loader;
